import * as React from "react";

import { ObservableArray } from "azure-devops-ui/Core/Observable";
import { ISection, LogViewer } from "azure-pipelines-ui/LogViewer";

export default class BasicLogViewerExample extends React.Component {
    private sections = new ObservableArray<ISection>([
        {
            getData: () => "Log from section 1\nline2\nline3\n[Warning]This is a warning\n[Error]This is an error.",
            hasData: true,
            isExpanded: true,
            key: "section1",
            title: "Section 1"
        },
        {
            getData: () => "Log from section 2\nSecond line",
            hasData: true,
            key: "section2",
            title: "Section 2"
        },
        {
            getData: () => "",
            hasData: false,
            key: "section3",
            title: "Section 3 -- Empty"
        }
    ]);

    public render(): JSX.Element {
        return <LogViewer sections={this.sections} />;
    }
}
